// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/poppins/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/poppins/Poppins-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/poppins/Poppins-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: 900;
  font-style: normal;
}

body {
  background-color: #fff;
  font-family: Poppins;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.background-color {
  background-color: yellowgreen;
}

.blur {
  background: rgba(219, 21, 21, 0.2);
  backdrop-filter: blur(8px);
}

.btn-icon-edit {
  padding: 10px;
  box-shadow:
    0 7px 14px rgb(50 50 93 / 10%),
    0 3px 6px rgb(0 0 0 / 8%);
  transform: translateY(0);
}

.padding-manage {
  padding-right: 110px;
}

.btn-icon {
  margin-top: 32px;
  padding: 10px;
  box-shadow:
    0 7px 14px rgb(50 50 93 / 10%),
    0 3px 6px rgb(0 0 0 / 8%);
  transform: translateY(0);
}

.btn-icon:hover {
  transform: translateY(-3px);
}

.btn-icon:hover svg {
  fill: #d9534f;
}

.btn-txt-icon span {
  vertical-align: middle;
}

.add-more-icon {
  background-color: none !important;
  color: #3ba371;
  box-shadow: none !important;
  padding: 0 !important;
  cursor: pointer;
  transform: translateY(0) !important;
  font-family:
    Open Sans,
    sans-serif !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}

.add-more-icon svg {
  margin: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

.add-more-icon span {
  display: inline-block;
  vertical-align: middle;
}

.add-more-icon:hover,
.add-more-icon:active,
.add-more-icon:target {
  color: #525f7f !important;
  box-shadow: none !important;
  background-color: transparent !important;
  background: none !important;
  padding: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* select.select-custom option {
  background-color: #fff !important;
  background: #fff !important;
  color: #000 !important;
  padding: 6px 12px !important;
  font-size: 15px; font-weight: 400 !important;
} */
/* select.select-custom option:nth-child(2) {
    background-color: #fb6340 !important;
    background: #fb6340 !important;
    color: #fff !important;
    padding: 6px 12px !important;
    font-size: 15px; font-weight: 600 !important;
    text-transform: uppercase;
  } */

/*onfocus="this.size=2;" onblur="this.size=0;" onchange="this.size=1; this.blur()"*/

.select-box {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.select-box--parent {
  display: block;
  position: relative;
  text-decoration: none;
  transition-duration: 0.5s;
  background: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  padding: 0.625rem 1.75rem 0.625rem 0.75rem;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
}

.select-box .select-box--parent:hover {
  cursor: pointer;
}

.select-box--parent:after {
  width: 24px;
  height: 24px;
  position: absolute;
  right: -2px;
  top: 6px;
  content: "\\2304";
  font-size: 24px;
  font-weight: 400;
  color: #666;
  text-align: center;
  line-height: 16px;
}

.select-box-dorpdown {
  border-radius: 0;
  border: none;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 99;
  transition: all 0.5s ease;
  margin: 0;
  padding: 0;
  background-color: #fff;
  border-radius: 0.375rem;
  border: none;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

/*ul.select-box li:hover > ul.select-box-dorpdown,
  ul.select-box li ul:hover {
    visibility: visible;
    opacity: 1;
    display: block;
  }*/
.select-box-dorpdown li {
  clear: both;
  width: 100%;
  border: none;
  border-radius: 0;
  padding: 0.325rem 0.75rem;
}

.select-box-dorpdown li:hover {
  color: #111;
}

.select-box-dorpdown li:last-of-type {
  background: #fff;
  color: #fb6340;
}

.select-box-dorpdown li:hover {
  background: #fff;
  color: #111;
}

.option-blue {
  color: blue;
}

.w-60 {
  width: 60%;
}

.option-select-property {
  background-color: #278e69;
  color: #fff;
}

.li-background-property {
  background-color: #278e69 !important;
  color: #fff !important;
}

.c-table-product {
  border: none;
  table-layout: fixed;
  width: 100%;
}

.c-table-product th,
.c-table-product td {
  border: none;
  width: 25%;
  word-break: break-word;
  white-space: normal;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 60%;
  }
}

b,
strong {
  font-weight: bold !important;
}

.card-img-top {
  border: 3px solid black;
  box-sizing: border-box;
}

.btn-box {
  width: 42px;
  height: 42px;
  background-color: #fff;
  border-radius: 6px;
  padding: 0 10px;
  margin: 0 0 0 15px;
  position: relative;
  text-align: center;
  font-size: 26px;
  line-height: 42px;
  box-shadow:
    0 3px 4px rgb(50 50 93 / 0),
    0 1px 3px rgb(0 0 0 / 0);
}

.btn-box:hover,
.btn-box:focus {
  background-color: #3ba371;
  color: #fff;
  box-shadow:
    0 4px 4px rgb(50 50 93 / 11%),
    0 1px 3px rgb(0 0 0 / 8%);
}

.btn-minus {
  color: red;
  font-size: 32px;
}

.btn-minus:hover {
  background-color: red;
}

.btn-addmore {
  display: inline-block;
  padding: 0;
  margin: 0 10px 0 0;
  font-size: 16px;
  line-height: 24px;
}

.btn-addmore .icon {
  font-size: 20px;
}

.btn-addmore:hover,
.btn-addmore:focus {
  color: #000;
}

/* .btn-addmore {
  display: inline-block;
  padding: 0;
  margin: 0 10px 0 0;
  font-size: 16px;
  line-height: 24px;
}

.btn-addmore .icon {
  font-size: 20px;
}

.btn-addmore:hover,
.btn-addmore:focus {
  color: #000;
} */

.table-views {
  border: none !important;
}

.table-views tr {
  border: none;
  margin-bottom: 25px;
}

.table-views th,
.table-views td {
  padding: 10px;
  border: none !important;
}

.table-views th {
  border: #eee solid 1px;
}

.table-views td {
  border: #eee solid 1px;
}

.uploadfiles {
  margin-bottom: 20px;
  display: block;
}

.uploadfiles h4 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
}

.uploadfiles--box {
  width: auto;
  display: inline-block;
  padding: 10px 60px 10px 10px;
  overflow: hidden;
  background-color: #f1f0f0;
  border-radius: 8px;
  position: relative;
  font-size: 14px;
  color: #000;
}

.uploadfiles--box a {
  display: block;
  text-decoration: underline;
  font-weight: 600;
  color: #000;
}

.uploadfiles--icon {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}

.btn-icon-close {
  width: 15px;
  height: 15px;
  background-color: #000;
  text-align: center;
  color: #fff !important;
  font-size: 8px;
  line-height: 14px;
  text-decoration: none !important;
  border: none;
  border-radius: 50px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.scroll-table-area {
  overflow-x: auto;
}

@media (max-width: 991px) {
  .scroll-table-area table {
    width: 150%;
  }
}

@media (max-width: 575px) {
  .scroll-table-area table {
    width: 240%;
  }
}

.fontsize-navbar {
  font-size: 17px;
}

.bg-green-color {
  color: #3ba371;
}

@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md .navbar-nav .fas {
    margin-right: 0.5rem;
    font-size: 15px;
  }
}

.spinner_css {
  right: 0;
  left: 0;
  /* top: 80px; */
}
.spinner_div{
  width: 100%;
  max-width: 100%;
  display: table-caption;
  margin: 0 auto;
}

.custom-css-select {
  border: none;
  border-bottom: 1px solid #b1b1b1 !important;
  border-radius: 0;
  height: 37px;
  padding: 0 0 0 0;
  box-shadow: none;
  background: transparent;
}

.custom_imput {
  position: absolute;
  opacity: 0;
  z-index: 99;
  cursor: pointer;
  height: 42px;
}

.map_div {
  height: 100%;
  width: 100%;
  /* display: grid; */
  /* justify-content: center; */
  /* box-shadow: 0 0 0 17px; */
  backdrop-filter: contrast(0.5);
  z-index: 999;
  position: relative;
}

.spinner {
  position: absolute;
  right: 0;
  left: 0;
  margin: 20% auto;
  display: block;
}

#navbar-main {
  z-index: 999;
}

.new_group>div {
  width: 100%;
}

.list_data {
  position: absolute;
  width: 55%;
  max-width: 100%;
  box-shadow: 0px 10px 60px 10px #ccc;
  padding: 5px 10px;
  z-index: 9;
  background: #fff;
  margin-top: 20px;
  list-style: none;
  height: 250px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.cursor--pointer img {
  height: 50px;
  width: 50px;
}

.cursor--pointer {
  padding: 0.4rem;
}

li.my-2.cursor--pointer:hover {
  background: #debb8e36;
  border-radius: 10px;
  cursor: pointer;
}

.map-view {
  margin-top: 1rem;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #42826c;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.normal-dashboard .table-responsive::-webkit-scrollbar {
  width: 6px;
  height: 4px;
}

/* Track */
.normal-dashboard .table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.normal-dashboard .table-responsive::-webkit-scrollbar-thumb {
  background: #42826c;
}

/* Handle on hover */
.normal-dashboard .table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.card {
  border: none !important;
}

.img-id {
  border-radius: 50px;
}

.user_list_chat {
  padding: 0;
  list-style: none;
  margin: 0;
  position: absolute;
  top: 80px;
  right: 0;
  width: 100%;
  max-width: 300px;
}

.w-15 {
  width: 150px;
}


/* Toggle switch styling */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: green;
  /* Green when off */
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: blue;
  /* Blue when on */
}

input:checked+.slider:before {
  transform: translateX(20px);
}


.active_title {
  font-weight: 600;
  color: #3ba371;
}


.chat-list {
  overflow-y: scroll;
  height: 400px;
}

.fa-trash {
  /* display: none; */
  animation-delay: 1s;
  transition: 0.5s ease-in-out;
}

.message-content:hover~.fa-trash {
  display: block;
}

.fa-trash:hover {
  display: block;
}


#sidenav-main .container-fluid {
  margin-top: 40px;
  overflow: hidden;
  padding: 0px !important;
}


.dropdown-menu::before {
  content: "";
  position: absolute;
  width: 0px;
  height: 0px;
  border-bottom: 10px solid #ffffff;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
  border-left: 10px solid transparent;
  top: -19px;
  right: 3px;

}

.notification-icon {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

h6.mb-1 {
  font-size: 14px;
  /* Slightly larger for readability */
  line-height: 1.5;
  /* Improve spacing for longer messages */
}

small.text-muted {
  font-size: 12px;
  /* Smaller font size for date and time */
  display: block;
  margin-top: 5px;
  /* Add spacing between message and timestamp */
}

.custom_dropdown {
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  z-index: 99;
}
.list-style-none {
  list-style: none;
  padding: 0 ;
  cursor: pointer;
}

.admin_pagination .paginateButton{
  background: transparent;
  border: 0;
  outline: 0;
  padding: 4px 15px;
}

.admin_pagination .paginateButton.active {
  background: #2b896c;
  border-radius: 4px;
  color: #fff;
  box-shadow: 0 0 15px 4px #ccc;
}

 

.admin_pagination .paginateButton.flase:hover {
  backgrounsd: #2b896c;
  border-radius: 4px;
  box-shadow: 0 0 12px 4px #ccc;
}
.new_bg{
  background: #2b896c24;
    padding: 44px 35px !important;
    margin-top: 20px;
}
.PhoneInputInput {
  border: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,+DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb;;6BAE2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb;;6BAE2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,mCAAmC;EACnC;;yBAEuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;EACxC,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;;;;GAMG;AACH;;;;;;;KAOK;;AAEL,mFAAmF;;AAEnF;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EAGZ,gDAAgD;EAChD,eAAe;AACjB;;AAEA;;;;;IAKI;AACJ;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB;;4BAE0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX;;6BAE2B;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;;AAGA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,UAAU;EACV,UAAU;;AAEZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;;;AAIA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;IACnB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;EACE,oBAAoB;AACtB","sourcesContent":["\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-ExtraBold.ttf\") format(\"truetype\");\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(\"./assets/fonts/poppins/Poppins-Black.ttf\") format(\"truetype\");\n  font-weight: 900;\n  font-style: normal;\n}\n\nbody {\n  background-color: #fff;\n  font-family: Poppins;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.background-color {\n  background-color: yellowgreen;\n}\n\n.blur {\n  background: rgba(219, 21, 21, 0.2);\n  backdrop-filter: blur(8px);\n}\n\n.btn-icon-edit {\n  padding: 10px;\n  box-shadow:\n    0 7px 14px rgb(50 50 93 / 10%),\n    0 3px 6px rgb(0 0 0 / 8%);\n  transform: translateY(0);\n}\n\n.padding-manage {\n  padding-right: 110px;\n}\n\n.btn-icon {\n  margin-top: 32px;\n  padding: 10px;\n  box-shadow:\n    0 7px 14px rgb(50 50 93 / 10%),\n    0 3px 6px rgb(0 0 0 / 8%);\n  transform: translateY(0);\n}\n\n.btn-icon:hover {\n  transform: translateY(-3px);\n}\n\n.btn-icon:hover svg {\n  fill: #d9534f;\n}\n\n.btn-txt-icon span {\n  vertical-align: middle;\n}\n\n.add-more-icon {\n  background-color: none !important;\n  color: #3ba371;\n  box-shadow: none !important;\n  padding: 0 !important;\n  cursor: pointer;\n  transform: translateY(0) !important;\n  font-family:\n    Open Sans,\n    sans-serif !important;\n  font-size: 1rem !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n}\n\n.add-more-icon svg {\n  margin: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.add-more-icon span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.add-more-icon:hover,\n.add-more-icon:active,\n.add-more-icon:target {\n  color: #525f7f !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  background: none !important;\n  padding: 0 !important;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n/* select.select-custom option {\n  background-color: #fff !important;\n  background: #fff !important;\n  color: #000 !important;\n  padding: 6px 12px !important;\n  font-size: 15px; font-weight: 400 !important;\n} */\n/* select.select-custom option:nth-child(2) {\n    background-color: #fb6340 !important;\n    background: #fb6340 !important;\n    color: #fff !important;\n    padding: 6px 12px !important;\n    font-size: 15px; font-weight: 600 !important;\n    text-transform: uppercase;\n  } */\n\n/*onfocus=\"this.size=2;\" onblur=\"this.size=0;\" onchange=\"this.size=1; this.blur()\"*/\n\n.select-box {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n\n.select-box--parent {\n  display: block;\n  position: relative;\n  text-decoration: none;\n  transition-duration: 0.5s;\n  background: #fff;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  padding: 0.625rem 1.75rem 0.625rem 0.75rem;\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n}\n\n.select-box .select-box--parent:hover {\n  cursor: pointer;\n}\n\n.select-box--parent:after {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  right: -2px;\n  top: 6px;\n  content: \"\\2304\";\n  font-size: 24px;\n  font-weight: 400;\n  color: #666;\n  text-align: center;\n  line-height: 16px;\n}\n\n.select-box-dorpdown {\n  border-radius: 0;\n  border: none;\n  width: 100%;\n  max-height: 300px;\n  overflow-y: auto;\n  position: absolute;\n  left: 0;\n  top: 100%;\n  z-index: 99;\n  transition: all 0.5s ease;\n  margin: 0;\n  padding: 0;\n  background-color: #fff;\n  border-radius: 0.375rem;\n  border: none;\n  -webkit-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n}\n\n/*ul.select-box li:hover > ul.select-box-dorpdown,\n  ul.select-box li ul:hover {\n    visibility: visible;\n    opacity: 1;\n    display: block;\n  }*/\n.select-box-dorpdown li {\n  clear: both;\n  width: 100%;\n  border: none;\n  border-radius: 0;\n  padding: 0.325rem 0.75rem;\n}\n\n.select-box-dorpdown li:hover {\n  color: #111;\n}\n\n.select-box-dorpdown li:last-of-type {\n  background: #fff;\n  color: #fb6340;\n}\n\n.select-box-dorpdown li:hover {\n  background: #fff;\n  color: #111;\n}\n\n.option-blue {\n  color: blue;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n.option-select-property {\n  background-color: #278e69;\n  color: #fff;\n}\n\n.li-background-property {\n  background-color: #278e69 !important;\n  color: #fff !important;\n}\n\n.c-table-product {\n  border: none;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.c-table-product th,\n.c-table-product td {\n  border: none;\n  width: 25%;\n  word-break: break-word;\n  white-space: normal;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 60%;\n  }\n}\n\nb,\nstrong {\n  font-weight: bold !important;\n}\n\n.card-img-top {\n  border: 3px solid black;\n  box-sizing: border-box;\n}\n\n.btn-box {\n  width: 42px;\n  height: 42px;\n  background-color: #fff;\n  border-radius: 6px;\n  padding: 0 10px;\n  margin: 0 0 0 15px;\n  position: relative;\n  text-align: center;\n  font-size: 26px;\n  line-height: 42px;\n  box-shadow:\n    0 3px 4px rgb(50 50 93 / 0),\n    0 1px 3px rgb(0 0 0 / 0);\n}\n\n.btn-box:hover,\n.btn-box:focus {\n  background-color: #3ba371;\n  color: #fff;\n  box-shadow:\n    0 4px 4px rgb(50 50 93 / 11%),\n    0 1px 3px rgb(0 0 0 / 8%);\n}\n\n.btn-minus {\n  color: red;\n  font-size: 32px;\n}\n\n.btn-minus:hover {\n  background-color: red;\n}\n\n.btn-addmore {\n  display: inline-block;\n  padding: 0;\n  margin: 0 10px 0 0;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.btn-addmore .icon {\n  font-size: 20px;\n}\n\n.btn-addmore:hover,\n.btn-addmore:focus {\n  color: #000;\n}\n\n/* .btn-addmore {\n  display: inline-block;\n  padding: 0;\n  margin: 0 10px 0 0;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.btn-addmore .icon {\n  font-size: 20px;\n}\n\n.btn-addmore:hover,\n.btn-addmore:focus {\n  color: #000;\n} */\n\n.table-views {\n  border: none !important;\n}\n\n.table-views tr {\n  border: none;\n  margin-bottom: 25px;\n}\n\n.table-views th,\n.table-views td {\n  padding: 10px;\n  border: none !important;\n}\n\n.table-views th {\n  border: #eee solid 1px;\n}\n\n.table-views td {\n  border: #eee solid 1px;\n}\n\n.uploadfiles {\n  margin-bottom: 20px;\n  display: block;\n}\n\n.uploadfiles h4 {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.uploadfiles--box {\n  width: auto;\n  display: inline-block;\n  padding: 10px 60px 10px 10px;\n  overflow: hidden;\n  background-color: #f1f0f0;\n  border-radius: 8px;\n  position: relative;\n  font-size: 14px;\n  color: #000;\n}\n\n.uploadfiles--box a {\n  display: block;\n  text-decoration: underline;\n  font-weight: 600;\n  color: #000;\n}\n\n.uploadfiles--icon {\n  width: 80px;\n  height: 80px;\n  margin-right: 20px;\n}\n\n.btn-icon-close {\n  width: 15px;\n  height: 15px;\n  background-color: #000;\n  text-align: center;\n  color: #fff !important;\n  font-size: 8px;\n  line-height: 14px;\n  text-decoration: none !important;\n  border: none;\n  border-radius: 50px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.scroll-table-area {\n  overflow-x: auto;\n}\n\n@media (max-width: 991px) {\n  .scroll-table-area table {\n    width: 150%;\n  }\n}\n\n@media (max-width: 575px) {\n  .scroll-table-area table {\n    width: 240%;\n  }\n}\n\n.fontsize-navbar {\n  font-size: 17px;\n}\n\n.bg-green-color {\n  color: #3ba371;\n}\n\n@media (min-width: 768px) {\n  .navbar-vertical.navbar-expand-md .navbar-nav .fas {\n    margin-right: 0.5rem;\n    font-size: 15px;\n  }\n}\n\n.spinner_css {\n  right: 0;\n  left: 0;\n  /* top: 80px; */\n}\n.spinner_div{\n  width: 100%;\n  max-width: 100%;\n  display: table-caption;\n  margin: 0 auto;\n}\n\n.custom-css-select {\n  border: none;\n  border-bottom: 1px solid #b1b1b1 !important;\n  border-radius: 0;\n  height: 37px;\n  padding: 0 0 0 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.custom_imput {\n  position: absolute;\n  opacity: 0;\n  z-index: 99;\n  cursor: pointer;\n  height: 42px;\n}\n\n.map_div {\n  height: 100%;\n  width: 100%;\n  /* display: grid; */\n  /* justify-content: center; */\n  /* box-shadow: 0 0 0 17px; */\n  backdrop-filter: contrast(0.5);\n  z-index: 999;\n  position: relative;\n}\n\n.spinner {\n  position: absolute;\n  right: 0;\n  left: 0;\n  margin: 20% auto;\n  display: block;\n}\n\n#navbar-main {\n  z-index: 999;\n}\n\n.new_group>div {\n  width: 100%;\n}\n\n.list_data {\n  position: absolute;\n  width: 55%;\n  max-width: 100%;\n  box-shadow: 0px 10px 60px 10px #ccc;\n  padding: 5px 10px;\n  z-index: 9;\n  background: #fff;\n  margin-top: 20px;\n  list-style: none;\n  height: 250px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.cursor--pointer img {\n  height: 50px;\n  width: 50px;\n}\n\n.cursor--pointer {\n  padding: 0.4rem;\n}\n\nli.my-2.cursor--pointer:hover {\n  background: #debb8e36;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.map-view {\n  margin-top: 1rem;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #42826c;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.normal-dashboard .table-responsive::-webkit-scrollbar {\n  width: 6px;\n  height: 4px;\n}\n\n/* Track */\n.normal-dashboard .table-responsive::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.normal-dashboard .table-responsive::-webkit-scrollbar-thumb {\n  background: #42826c;\n}\n\n/* Handle on hover */\n.normal-dashboard .table-responsive::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.card {\n  border: none !important;\n}\n\n.img-id {\n  border-radius: 50px;\n}\n\n.user_list_chat {\n  padding: 0;\n  list-style: none;\n  margin: 0;\n  position: absolute;\n  top: 80px;\n  right: 0;\n  width: 100%;\n  max-width: 300px;\n}\n\n.w-15 {\n  width: 150px;\n}\n\n\n/* Toggle switch styling */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: green;\n  /* Green when off */\n  transition: 0.4s;\n  border-radius: 20px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked+.slider {\n  background-color: blue;\n  /* Blue when on */\n}\n\ninput:checked+.slider:before {\n  transform: translateX(20px);\n}\n\n\n.active_title {\n  font-weight: 600;\n  color: #3ba371;\n}\n\n\n.chat-list {\n  overflow-y: scroll;\n  height: 400px;\n}\n\n.fa-trash {\n  /* display: none; */\n  animation-delay: 1s;\n  transition: 0.5s ease-in-out;\n}\n\n.message-content:hover~.fa-trash {\n  display: block;\n}\n\n.fa-trash:hover {\n  display: block;\n}\n\n\n#sidenav-main .container-fluid {\n  margin-top: 40px;\n  overflow: hidden;\n  padding: 0px !important;\n}\n\n\n.dropdown-menu::before {\n  content: \"\";\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  border-bottom: 10px solid #ffffff;\n  border-right: 10px solid transparent;\n  border-top: 10px solid transparent;\n  border-left: 10px solid transparent;\n  top: -19px;\n  right: 3px;\n\n}\n\n.notification-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  margin-right: 10px;\n  flex-shrink: 0;\n}\n\nh6.mb-1 {\n  font-size: 14px;\n  /* Slightly larger for readability */\n  line-height: 1.5;\n  /* Improve spacing for longer messages */\n}\n\nsmall.text-muted {\n  font-size: 12px;\n  /* Smaller font size for date and time */\n  display: block;\n  margin-top: 5px;\n  /* Add spacing between message and timestamp */\n}\n\n.custom_dropdown {\n  display: flex;\n  flex-direction: column-reverse;\n  position: absolute;\n  z-index: 99;\n}\n.list-style-none {\n  list-style: none;\n  padding: 0 ;\n  cursor: pointer;\n}\n\n.admin_pagination .paginateButton{\n  background: transparent;\n  border: 0;\n  outline: 0;\n  padding: 4px 15px;\n}\n\n.admin_pagination .paginateButton.active {\n  background: #2b896c;\n  border-radius: 4px;\n  color: #fff;\n  box-shadow: 0 0 15px 4px #ccc;\n}\n\n \n\n.admin_pagination .paginateButton.flase:hover {\n  backgrounsd: #2b896c;\n  border-radius: 4px;\n  box-shadow: 0 0 12px 4px #ccc;\n}\n.new_bg{\n  background: #2b896c24;\n    padding: 44px 35px !important;\n    margin-top: 20px;\n}\n.PhoneInputInput {\n  border: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
